
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policy/personal-info-collection-statement",
      function () {
        return require("private-next-pages/policy/personal-info-collection-statement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policy/personal-info-collection-statement"])
      });
    }
  